import firebase from "datastore/database";
import store from "datastore/store";
import { addBusinessError, addBusinessSuccess } from "actions/business";

import observeFeedback from "./observeFeedback";

export default async function fetchAll(businessUid) {
  firebase
    .firestore()
    .collection("businesses")
    .doc(businessUid)
    .onSnapshot((doc) => {
      if (doc.exists) {
        store.dispatch(addBusinessSuccess(doc.data()));
      } else {
        store.dispatch(addBusinessError());
      }
    });

  observeFeedback(businessUid);
}
